exports = module.exports = require("../../../../../css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".spectrum--lightest  {\n  background-color: rgb(255, 255, 255);\n  -webkit-tap-highlight-color: rgba(0,0,0,0);\n}\n", "", {"version":3,"sources":["/jenkins/workspace/CCX-Comments-Release/node_modules/@react/react-spectrum/spectrum-css/page/multiStops/lightest.css"],"names":[],"mappings":"AAAA;EACE,qCAAqC;EACrC,2CAA2C;CAC5C","file":"lightest.css","sourcesContent":[".spectrum--lightest  {\n  background-color: rgb(255, 255, 255);\n  -webkit-tap-highlight-color: rgba(0,0,0,0);\n}\n"],"sourceRoot":""}]);

// exports
